"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeAxiosInterceptors = exports.apiBaseUrl = void 0;
const axios_1 = __importDefault(require("axios"));
const config_1 = __importDefault(require("../config"));
exports.apiBaseUrl = config_1.default.apiUrl;
const API = axios_1.default.create({
    baseURL: exports.apiBaseUrl,
    timeout: 15000,
    withCredentials: true
});
const initializeAxiosInterceptors = (ssoStore) => {
    API.interceptors.response.use((response) => {
        return response;
    }, (error) => {
        var _a;
        if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
            ssoStore.doLogout();
        }
        return Promise.reject(error);
    });
};
exports.initializeAxiosInterceptors = initializeAxiosInterceptors;
exports.default = API;
